<template>
  <div>
    <v-data-table
      disable-pagination
      style="width: 100%"
      :headers="headers"
      :items="nomatches"
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr>
          <td >
            {{ props.item.id }}
          </td>
          <td>
            <a
              href="#"
              v-on:click.stop="goToUser(props.item.customer_id)"
            >{{ props.item.user.name }}</a>
          </td>
          <td>
            <a
              href="#"
              v-on:click.stop="goToDriver(props.item.driver_id)"
              v-html="'<span><b>' + props.item.driver.id + '</b> ' + props.item.driver.name + '</span>'"
            ></a>
          </td>
          <td >{{ props.item.description }}</td>
          <td>
            <v-btn
              @click="remove(props.item)"
              class="text-none"
              x-small
              flat
            >{{ props.item.revoked ? 'Reinstate' : 'Revoke' }}</v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import { setTimeout } from "timers";
axios.defaults.withCredentials = true;

export default {
  name: "no_match_list",
  components: {},
  props: {
    nomatches: Array,
  },
  data: function() {
    return {
      dialog: Object,
      headers: [
        {
          text: "ID",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Customer",
          align: "left",
          sortable: false,
          value: "customer"
        },
        {
          text: "Driver",
          align: "left",
          sortable: false,
          value: "driver"
        },
        {
          text: "Description",
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: "Remove",
          align: "left",
          sortable: false,
          value: "remove"
        }
      ]
    };
  },
  methods: {
    remove(nomatch) {
      console.log("Remove called");
      console.log(nomatch);

      var url = `${this.$store.state.apiUrl}/no_match/delete?id=${nomatch.id}`;

      var self = this;

      axios({
        url: url,
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
         self.$emit('reload');
        })
        .catch(function(err) {
          console.error(err);
        });
    },
    goToUser: function(id) {
      window.open(`/customer/view/${id}`, "_blank");
    },
    goToDriver: function(id) {
      window.open(`/driver/view/${id}`, "_blank");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}
</style>
